@if (type === 'small') {
    <sirius-media-slider-thumbnails
        [items]="items"
        [imageData]="imageData"
        (selectedIndex)="setIndex($event)"
        (clickEvent)="onClick($event)"
        (scrollNextEvent)="onScrollNext()"
        (scrollPreviousEvent)="onScrollPrevious()">
    </sirius-media-slider-thumbnails>
} @else {
    <sirius-slider
        (selectedIndex)="setIndex($event)"
        (scrollNextEvent)="onScrollNext()"
        (scrollPreviousEvent)="onScrollPrevious()">
        @for (item of items; track $index) {
            <div class="sir-media-container">
                <div class="sir-media">
                    @switch (item.type) {
                        @case ('image') {
                            <sirius-image-item
                                [image]="item | cast"
                                [roundedCorners]="true"
                                [imageData]="imageData[3]">
                            </sirius-image-item>
                        }
                        @case ('video') {
                            <sirius-video-item
                                #video
                                [video]="item | cast"
                                [canPlay]="index === $index"
                                (click)="$event.preventDefault(); $event.stopPropagation()">
                            </sirius-video-item>
                        }
                    }
                </div>
                @if (showDescription) {
                    <span class="sir-description sir-text-style-paragraph-m-default">{{ item.title }}</span>
                }
            </div>
        }
    </sirius-slider>
}
@if (open) {
    <sirius-media-collection-modal
        [items]="items"
        [startIndex]="index"
        (closeEvent)="onClose($event)"
        [showDescription]="showDescription">
    </sirius-media-collection-modal>
}
